// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"Locations_dropzone__1IvyB","buttons":"Locations_buttons__2mMGH","table":"Locations_table__1MBk_","csv-download":"Locations_csv-download__19otr"};